
import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { Power3, gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Links from '../components/Links'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const NewStudentHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100vh;
  display: grid;
  width: 100vw;
  align-content: center;
  background:var(--black);

  .student-hero {
    margin: 12px auto 0px auto;
    max-width:80vw;
    max-height:50vh;
    border-radius: 6px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    ${media.medium}{
      max-width: 400px;
      max-height: 400px;
    }
  }
`

const StudentName = styled.h1`
  font-weight: 100;
  font-size: 13vw;
  text-align: center;
  line-height: 0.8;
  letter-spacing: -0.08em;
  text-transform: uppercase;
  margin: 0;
  padding-top: 12px;
  width: 100%;
  color: var(--light);
  font-family:var(--serif);
  font-weight:100;
  font-variation-settings: 'wght' 100;

  ${media.medium} {
  }

  ${media.large} {
  }

  ${media.xLarge} {
  }

  .first-name {
    opacity: 1;
    display: block;
    text-align: center;
  }
  .last-name {
    display: block;
    opacity: 1;
  }
`

export default function StudentHeader ({ student }) {
  let firstName = useRef(null)
  let lastName = useRef(null)
  let studentImage = useRef(null)

  if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
    gsap.config({ nullTargetWarn: false })
  }

  useEffect(() => {
    gsap.from(firstName, 1.5, {
      y: '-100vh',
      ease: Power3.easeOut,
      delay: 0.4
    })

    gsap.from(lastName, 1.5, {
      y: '100vh',
      scale: 0.0,
      ease: Power3.easeOut,
      delay: 0.4
    })

    gsap.from('.student-hero', 2, {
      scale: 0.8,
      opacity: 0.0,
      ease: Power3.easeOut,
      delay: 0.4
    })
  }, [])

  return (
    <NewStudentHeader>
      <StudentName>
        <span ref={el => {
          firstName = el
        }}
        className="first-name"
        >
          {student.first_name}
        </span>
        <Img
          className="student-hero"
          ref={el => {
            studentImage = el
          }}
          fixed={student.hero_image.asset.fixed}
          alt={student.first_name}
        />

        <span ref={el => {
          lastName = el
        }}
        className="last-name">
          {student.last_name}
        </span>
      </StudentName>
      <Links links={student.links}/>
    </NewStudentHeader>

  )
}
